import request from 'superagent';

import { Observable } from 'rxjs/Observable';
import { CONNECTION_CHANGE } from './actions';
import { detectUserDeviceType, detectTorpedo7ClubMember } from './utils';

export const sendWebChatReadyEpic = action$ =>
  action$
    .ofType(CONNECTION_CHANGE)
    .filter(action => action.connectionStatus === 2)
    .take(1)
    .flatMap(action => {
      if (action.connectionStatus === 2) {
        window.parent.postMessage(
          {
            source: 'ambitChatPanel',
            type: 'webChatReady'
          },
          '*'
        );
      }

      return Observable.empty();
    });

export const sendUserDataEpic = (action$, store) =>
  action$
    .ofType(CONNECTION_CHANGE)
    .filter(action => action.connectionStatus === 2)
    .take(1)
    .flatMap(() => {
      const state = store.getState();

      const doSendUserData = value =>
        state.connection.botConnection
          .postActivity({
            type: 'event',
            from: state.connection.botConnection.user,
            locale: 'en-GB',
            name: 'userDataAnalytics',
            value
          })
          .subscribe();

      request.get('https://ipinfo.io/json').end((err, res) => {
        if (err) {
          const value = { userDevice: { type: detectUserDeviceType() } };

          doSendUserData(JSON.stringify(value));
          console.log('Loading IP geolocation failed', err);
        } else {
          const value = { userDevice: { type: detectUserDeviceType() }, geolocation: res.body };
          doSendUserData(JSON.stringify(value));
        }
      });

      return Observable.empty();
    });

export const sendIsTorpedo7ClubMember = (action$, store) =>
  action$
    .ofType(CONNECTION_CHANGE)
    .filter(action => action.connectionStatus === 2)
    .take(1)
    .flatMap(() => {
      const state = store.getState();

      const isTorpedo7ClubMember = detectTorpedo7ClubMember();

      if (isTorpedo7ClubMember) {
        state.connection.botConnection
          .postActivity({
            type: 'event',
            from: state.connection.botConnection.user,
            locale: 'en-GB',
            name: 'isTorpedo7ClubMember',
            value: JSON.stringify(true)
          })
          .subscribe();
      }

      return Observable.empty();
    });



// WEBPACK FOOTER //
// ./src/reducers/connection/epics.js